import { useEffect, useState } from "react";
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { cn } from "@/lib/utils";

// ESTORNO-AUDITORIA (I.160, E3/E9): confirmação com motivo obrigatório — estorno de baixa e desfazer conciliação.
// O botão só libera com o motivo preenchido; o banco também recusa sem motivo.
interface ReasonConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  reasonLabel?: string;
  confirmText?: string;
  cancelText?: string;
  variant?: 'default' | 'destructive';
  onConfirm: (reason: string) => void;
  isLoading?: boolean;
}

export function ReasonConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  reasonLabel = "Motivo",
  confirmText = "Confirmar",
  cancelText = "Cancelar",
  variant = 'default',
  onConfirm,
  isLoading = false,
}: ReasonConfirmDialogProps) {
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (!open) setReason("");
  }, [open]);

  const trimmed = reason.trim();

  const handleConfirm = () => {
    if (!trimmed || isLoading) return;
    onConfirm(trimmed);
    onOpenChange(false);
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <div className="space-y-2">
          <Label htmlFor="reason-confirm-text">{reasonLabel} *</Label>
          <Textarea
            id="reason-confirm-text"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Descreva o motivo"
            rows={3}
            disabled={isLoading}
          />
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading}>{cancelText}</AlertDialogCancel>
          <Button
            onClick={handleConfirm}
            disabled={!trimmed || isLoading}
            className={cn(variant === 'destructive' && "bg-destructive hover:bg-destructive/90")}
          >
            {isLoading ? 'Processando...' : confirmText}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
